import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import MainTitle from '../../components/template/MainTitle'
import SubTitle from '../../components/template/SubTitle'
import { classNames, getAlphabetArray } from '../../components/utils/Utils'
import api from '../../components/utils/api';

const AvailableClassPage = () => {
    const params = useParams()
    const [classes, setClasses] = useState([])
    const [numOfClasses, setNumOfClasses] = useState(0)
    const [alphabetFilter, setAlphabetFilter] = useState('all')

    useEffect(() => {
        const fetchData = async () => {
            const generalModelResponse = await api.get(`/api/general-models/resolve?model_name=${params.generalModelName}`)
            const experimentId = generalModelResponse.data.experiment_id

            const experimentResponse = await api.get(`/api/experiments/${experimentId}`)
            const eventClasses = experimentResponse.data.event_classes
            setNumOfClasses(Object.keys(eventClasses).length)
            setClasses(getAlphabetArray(Object.keys(eventClasses)))
        }
        if (params?.generalModelName) fetchData()
    }, [params])

    return (
        <div className='default-background'>
            {params?.generalModelName && <>
                <SubTitle title='Available Classes' />
                <MainTitle title={`${params.generalModelName} (${numOfClasses})`} />
                <div className='flex justify-between my-2'>{
                    ['all', ...Array.from(classes.keys())].map((e, i) => <button
                        key={i} className={classNames(
                            'py-3 text-sm text-gray-500',
                            e === alphabetFilter ? 'font-bold text-violet-500' : 'text-gray-500'
                        )}
                        onClick={() => setAlphabetFilter(e)}
                    >{e.toUpperCase()}</button>)
                }</div>
                <div>
                    {Array.from(classes.keys()).filter(e => alphabetFilter === 'all' || e === alphabetFilter).map((e, i) =>
                        <div key={i} className='text-left my-3'>
                            <div className='text-left font-bold p-3'>{`${e.toUpperCase()} (${classes.get(e).length.toString()})`}</div>
                            <hr />
                            <div className='md:grid md:grid-cols-3'>
                                {classes.get(e).map((className, idx) => <div key={idx} className='px-3 py-1'>{className}</div>)}
                            </div>
                        </div>)}
                </div>
            </>}
        </div>
    )
}

export default AvailableClassPage